import { apiDelete, apiGet, apiUpload } from "./api";

export async function getMediaAssets(params = {}) {
  return apiGet("/media/", params);
}

export async function uploadMediaFiles(formData) {
  return apiUpload("/media/upload/", formData);
}

export async function deleteMediaAsset(assetId) {
  return apiDelete(`/media/${assetId}/`);
}

export async function getPortfolios(params = {}) {
  return apiGet("/media/portfolios/", params, { omitSiteHeader: true });
}


export async function uploadFiles(files = [], category = "Media") {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  if (category) formData.append("category", category);
  return uploadMediaFiles(formData);
}

export async function deleteUpload(assetId) {
  return deleteMediaAsset(assetId);
}

export async function batchUploadProducts(payload = {}) {
  const formData = new FormData();
  if (payload.sheet_file) formData.append("sheet_file", payload.sheet_file);
  if (payload.image_zip) formData.append("image_zip", payload.image_zip);
  if (payload.category) formData.append("category", payload.category);
  return apiUpload("/catalog/admin/products/batch-upload/", formData);
}

export function downloadBatchProductCSVTemplate() {
  const csv = [
    "name,slug,sku,price,stock,category_id,short_description,featured_image",
    "Sensor Flow Meter,sensor-flow-meter-iot,IOT-001,250000,20,1,Sensor flow meter untuk monitoring air,flow-meter.jpg",
    "ESP32 WiFi Controller,esp32-wifi-controller,IOT-002,120000,50,2,Board ESP32 untuk kontrol sensor,esp32.jpg",
  ].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "template_batch_products.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
